import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight } from "lucide-react";
import { business } from "../content/site";
import { trackEvent } from "../lib/analytics";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";

const PriceCTA = ({ context = "" }) => {
  const c = useCopy("priceCta");
  const cm = useCopy("common");
  const lp = useLp();
  return (
    <div className="mt-12 bg-obsidian text-paper rounded-sm p-8 sm:p-10" data-testid="price-cta">
      <h2 className="text-xl sm:text-2xl font-semibold text-paper">{c.title}</h2>
      <p className="mt-3 text-[15px] text-slate-300 leading-relaxed max-w-2xl">{c.text}</p>
      <div className="mt-6 flex flex-wrap gap-3">
        <Link
          to={lp("/contacto/")}
          data-testid="price-cta-budget"
          onClick={() => trackEvent("cta_budget_click", { location: `price_cta:${context}` })}
          className="btn-primary"
        >
          {cm.quote} <ArrowRight size={15} aria-hidden="true" />
        </Link>
        <a
          href={business.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="price-cta-whatsapp"
          onClick={() => trackEvent("whatsapp_click", { location: `price_cta:${context}` })}
          className="btn-secondary !border-paper/30 !text-paper hover:!bg-paper hover:!text-ink"
        >
          <MessageCircle size={15} aria-hidden="true" /> {cm.whatsapp}
        </a>
      </div>
    </div>
  );
};

export default PriceCTA;
